import type { Item } from '@/common/api/types/items';
import {
  useEstimationsQuery,
  useGetEstimationSchemeQuery,
} from '@/common/queries/useGetEstimationScheme';
import { useItemFetchQuery } from '@/common/queries/useGetItemFetchQuery';
import { useGetItemStatusesQuery } from '@/common/queries/useGetItemStatusesQuery';
import { useItemTypesQuery } from '@/common/queries/useItemTypesQuery';
import { useGetTeamsQuery } from '@/features/teams/queries/useGetTeamsQuery';

const PANEL_QUERY_OPTIONS = {
  refetchOnMount: false,
} as const;

export const useItemPanelQuery = (item: Item, enabled = true) => {
  const { data: itemStatuses = [] } = useGetItemStatusesQuery({
    ...PANEL_QUERY_OPTIONS,
    enabled,
  });
  const { data: itemTypes = [] } = useItemTypesQuery({ ...PANEL_QUERY_OPTIONS, enabled });
  const { data: teamsResponse } = useGetTeamsQuery({ ...PANEL_QUERY_OPTIONS, enabled });

  const { data: estimations = [] } = useEstimationsQuery({ enabled });

  const itemEstimation = item.estimationId
    ? estimations.find((estimation) => estimation.id === item.estimationId)
    : undefined;

  const { data: estimationScheme } = useGetEstimationSchemeQuery({
    schemeId: itemEstimation?.estimationSchemeId ?? 0,
  });

  const teams = teamsResponse?.data ?? [];
  const parentItem = useItemFetchQuery({
    itemId: item.parentId ?? 0,
    enabled: enabled && item.parentId != null,
  }).data;

  return {
    itemStatuses,
    itemTypes,
    teams,
    parentItem,
    estimationScheme,
    estimations,
  };
};
